"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.isWhitelisted = void 0;
const assertString_1 = require("./util/assertString");
function isWhitelisted(str, chars) {
    (0, assertString_1.assertString)(str);
    for (let i = str.length - 1; i >= 0; i--) {
        if (chars.indexOf(str[i]) === -1) {
            return false;
        }
    }
    return true;
}
exports.isWhitelisted = isWhitelisted;
